
import * as types from '../../mutation-types'
import {setItems} from '../../../util/helpers'

const state = {
  logginIn: false,
  sessionExpired: false,
  updateAvailable: false,
  versionAvailable: null,
  reservationIssues: [],
  csCacheKey: null,
  csReloadReq: true,
  allowScreenLock: false, // set via $ftAPI().setGlobalAppState -- disable screen locking if screen lock function is enabled, but app is in state where we should never lock (like has hold on locked records)
  screenLocked: false, // set via $ftAPI().setGlobalAppState
  jwt: null, // set via $ftAPI().setGlobalAppState
  key: null, // set via $ftAPI().setGlobalAppState
  userLock: false, // set via $ftAPI().setGlobalAppState
  lastUsers: [], // set via $ftAPI().setGlobalAppState
  lastActivity: null
}

const mutations = {
  [types.SET_APP_STATE] (state, appState) {
    setItems(state, appState, state)
  },
  [types.SET_CS_CACHE_KEY] (state, csCacheKey) {
    state.csCacheKey = csCacheKey
  },
  [types.SET_CS_RELOAD_REQ] (state, reloadReq) {
    state.csReloadReq = reloadReq
  },
  [types.SET_CS_LOGGING_IN] (state, loggingIn) {
    state.logginIn = loggingIn
  },
  [types.SET_CS_SESSION_EXPIRED] (state, expired) {
    state.sessionExpired = expired
  }
}

export default {
  state,
  mutations
}
